import { exportApi } from '../api/resources';

/**
 * Sauvegarde complète de la société, téléchargée en un fichier JSON.
 *
 * <p>Deux écrans exportaient chacun leur part — la fiche société depuis les
 * réglages, cinq collections depuis les archives — et aucun ne sortait le
 * stock, les employés, les dépenses ou les ventes. Le serveur assemble
 * désormais l'ensemble ({@code GET /api/export}, patron seulement) ; les deux
 * écrans passent par ici.
 */

/**
 * Nom du fichier de sauvegarde, daté du jour de l'export.
 *
 * @param {string|number|Date} [instant] instant de l'export ; maintenant à défaut
 * @returns {string} par exemple `swisstech-sauvegarde-2026-10-06.json`
 */
export function nomDeSauvegarde(instant) {
  const date = instant ? new Date(instant) : new Date();
  const valide = Number.isNaN(date.getTime()) ? new Date() : date;
  const jour =
    valide.getFullYear() +
    '-' +
    String(valide.getMonth() + 1).padStart(2, '0') +
    '-' +
    String(valide.getDate()).padStart(2, '0');
  return 'swisstech-sauvegarde-' + jour + '.json';
}

/**
 * Fait télécharger un objet en fichier JSON lisible.
 *
 * @param {object} donnees contenu du fichier
 * @param {string} nomFichier nom proposé au navigateur
 */
export function telechargeJson(donnees, nomFichier) {
  const blob = new Blob([JSON.stringify(donnees, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  try {
    const lien = document.createElement('a');
    lien.href = url;
    lien.download = nomFichier;
    lien.click();
  } finally {
    URL.revokeObjectURL(url);
  }
}

/**
 * Demande la sauvegarde complète au serveur et la fait télécharger.
 *
 * @returns {Promise<string>} le nom du fichier téléchargé
 * @throws {Error} l'erreur de l'API (403 pour un rôle autre que le patron)
 */
export async function telechargeLaSauvegarde() {
  const donnees = await exportApi.tout();
  const nom = nomDeSauvegarde(donnees && donnees.exporteLe);
  telechargeJson(donnees, nom);
  return nom;
}
